import { Link, useNavigate, useParams } from 'react-router-dom'
import useModalTrigger from 'magik-react-hooks/useModalTrigger'
import ThemeForm from '../../components/ThemeForm'
import { MAIN_LANG } from '../../consts'
import { useUpdateTheme, useTheme, useDeleteTheme } from '../../hooks/themes'
import { ThemeDetail } from '../../types'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import Page from '../../components/Page'
import Header from '../../components/Header'

export default function ThemeEdit() {
  const { id } = useParams()
  const { data: theme } = useTheme(+id!)
  const updateTheme = useUpdateTheme()
  const deleteTheme = useDeleteTheme()
  const [modalRm, modalRmActions] = useModalTrigger<ThemeDetail>()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/themes">Temi</Link>
            </li>
            {theme!.parent_theme_data && (
              <li className="breadcrumb-item">
                <Link to={`/themes/${theme!.parent_theme}`}>
                  {theme!.parent_theme_data.title[MAIN_LANG]}
                </Link>
              </li>
            )}
            <li className="breadcrumb-item active" aria-current="page">
              {theme!.title[MAIN_LANG]}
            </li>
          </ol>
        </nav>
        <button
          className="btn  btn-danger"
          onClick={() => modalRmActions.open(theme)}
        >
          <i className="bi bi-trash3-fill"></i> Elimina
        </button>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <ThemeForm
          key={theme!.id}
          theme={theme}
          save={(theme) =>
            updateTheme.mutateAsync(theme).then(() =>
              toast.success('Tema salvato con successo!', {
                position: 'bottom-right',
                theme: 'colored',
              })
            )
          }
        />
      </div>
      <Modal centered isOpen={modalRm.isOpen} toggle={modalRmActions.toggle}>
        <ModalHeader toggle={modalRmActions.toggle}>Elimina</ModalHeader>
        <ModalBody>
          {modalRm.value && (
            <div className="pt-3 pb-3">
              Sei sicuro di voler eliminare il Tema{' '}
              {modalRm.value.title[MAIN_LANG]} ?
            </div>
          )}
        </ModalBody>
        <ModalFooter className="d-flex justify-content-between">
          <button
            onClick={modalRmActions.toggle}
            className="btn btn-outline-primary"
          >
            Annulla
          </button>
          <button
            className="btn  btn-danger"
            disabled={deleteTheme.isLoading}
            onClick={async () => {
              await deleteTheme.mutateAsync(modalRm.value!.id)
              navigate('/themes')
            }}
          >
            <i className="bi bi-trash3-fill"></i> Elimina
          </button>
        </ModalFooter>
      </Modal>
    </Page>
  )
}
